import axios from 'axios';
import { RootController } from '../../eye-test/controller/root.controller';
import { IFinalTelemetryContainer, ITelemetryData } from './typings';

const doPostTelemetry = (page: string, extra: ITelemetryData | IFinalTelemetryContainer) => {
	const today = new Date();
	const date = today.getFullYear() + '-' + (today.getMonth() + 1) + '-' + today.getDate();
	const time = today.getHours() + ':' + today.getMinutes() + ':' + today.getSeconds();
	const dateTime = date + ' ' + time;
	const body = {
		time: dateTime,
		data: {
			page,
			extra
		}
	};

	console.log('Telemetry:', body);

	axios
		.post('https://www.videbis.at/api/v1/testdata/st/' + RootController.globalUserID, body)
		.then(response => {
			console.log('Server replied!');
			console.log(response);
		})
		.catch(err => {
			console.log(err.response);
		});
};

export const postTelemetry = (page: string, extra: ITelemetryData | IFinalTelemetryContainer) => {
	if (!RootController.globalUserID) {
		const body = {
			idRequest: true,
			userAgent: navigator.userAgent,
			height: window.screen.height,
			width: window.screen.width,
			url: window.location.href
		};

		console.log('TELEMETRY: NO ID, FETCHING ID', body);

		axios
			.post('https://www.videbis.at/api/v1/testdata/st', body)
			.then(response => {
				console.log('Server replied on ID request!', response.data.id);
				RootController.globalUserID = response.data.id;
				doPostTelemetry(page, extra);
			})
			.catch(err => {
				console.log(err.response);
			});
		return;
	} else {
		doPostTelemetry(page, extra);
	}
};

export const postEnd = (reason: string, url: string | null) => {
	if (!RootController.globalUserID) {
		console.log('NO TELEMETRY, NO ID, STILL SHOULD REDIRECT', url);
		if (url) {
			window.location.replace(url);
		}
		return;
	}

	const today = new Date();
	const date = today.getFullYear() + '-' + (today.getMonth() + 1) + '-' + today.getDate();
	const time = today.getHours() + ':' + today.getMinutes() + ':' + today.getSeconds();
	const dateTime = date + ' ' + time;
	const body = {
		time: dateTime,
		end: reason
	};

	console.log('END', body);

	axios
		.post('https://www.videbis.at/api/v1/testdata/st/' + RootController.globalUserID, body)
		.then(response => {
			console.log('Server replied!');
			console.log(response);
			if (url) {
				window.location.replace(url);
			}
		})
		.catch(err => {
			if (url) {
				window.location.replace(url);
			}

			console.log(err.response);
		});
};
